import React, {useState, useEffect} from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import mtStyles from '../../styles/mtStyles';
import DataTable from '../datatable';
import StarIcon from '@material-ui/icons/Star';
import StarBorderIcon from '@material-ui/icons/StarBorder';
import { useSelector, useDispatch } from 'react-redux';
import { Button, Link, Typography } from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import { useSnackbar } from 'material-ui-snackbar-provider';
import { useTranslation } from 'react-i18next';
import { TableCell, TableRow, IconButton, Box } from '@material-ui/core';
import { fetchPrintTemplates, setOngoingPrint } from '../../actions/templates';

import { placeholders } from '../placeholders';
import convertIsoDatetimeToDate from '../../functions/convertIsoDatetimeToDate';

import { useAddPrintTemplateMutation, useDeletePrintTemplateMutation, useGetAllPrintTemplatesQuery, useGetPrintTemplatesByIdQuery, useUpdatePrintTemplateMutation } from '../../apis/backend';

const PrintTemplateList = (props) => {
  const chainId = useSelector(state => state.doris.selectedChain);
  const siteId = useSelector(state => state.doris.selectedSite);

  const [openDialog, setOpenDialog] = useState(false);
  const [ongoingCandidate, setOngoingCandidate] = useState();

  const snackbar = useSnackbar();
  const history = useHistory();
  const {t, i18n} = useTranslation();
  const dispatch = useDispatch();

  const classes = mtStyles();

  const [skipGetPrints, setSkipGetPrints] = useState(true);
  const { data: prints, isLoading: isLoadingPrints } = useGetAllPrintTemplatesQuery({
    chainId, siteId }, { skip: skipGetPrints}
  );

  const [addPrint, addResult] = useAddPrintTemplateMutation();
  const [updatePrint, updateResult] = useUpdatePrintTemplateMutation();
  const [deletePrint, deleteResult] = useDeletePrintTemplateMutation();

  useEffect(() => {
    if (chainId && siteId) {
      setSkipGetPrints(false);
    }
  }, [chainId, siteId]);

  const editPrintTemplate = (id) => {
    history.push(`/templates/print/${id}`);
  };

  const columns = [
    {
      Header: 'Default',
      accessor: 'ongoing',
    },
    {
      Header : 'id',
      accessor : 'id'
    },
    {
      Header : t('title'),
      accessor : 'title'
    },
    {
      Header : t('text-content'),
      accessor : 'message_content'
    }
  ];

  const mapTableBody = (templates) => {
    return (
      <>
        {templates.map((template, index) => (
          <TableRow
            style={index % 2 ? { background: '#FBFBFB' } : { background: 'white' }}
            key={index}>
            <TableCell style={{ width: '1%', textAlign: 'center' }}>
              <Link
                onClick={() => {
                  setOngoingCandidate(template);
                  setOpenDialog(true);
                }}>
                <IconButton>
                  { template.ongoing
                    ? <StarIcon color="primary" />
                    : <StarBorderIcon className={classes.unstarred} />
                  }
                </IconButton>
              </Link>
            </TableCell>
            <TableCell>
              <Typography noWrap>{template.id}</Typography>
            </TableCell>
            <TableCell>
              <Link
                className={classes.link}
                onClick={() => editPrintTemplate(template.id)}
              >
                <Typography noWrap>{template.title}</Typography>
              </Link>
            </TableCell>
            <TableCell style={{ maxWidth: 400 }}>
              <Typography noWrap>{replacePlaceholderFields(template.message_content)}</Typography>
            </TableCell>
          </TableRow>
        ))}
      </>
    );
  };

  const ongoingTemplate = prints?.find(print => print.ongoing);
  const printTemplates = prints
    ? prints.filter(print => !print.ongoing)
    : [];

  return (
    <>
      <Box className={classes.pageActions}></Box>

      <DataTable
        isLoading={isLoadingPrints}
        columns={columns}
        data={ongoingTemplate ? [ongoingTemplate, ...printTemplates] : printTemplates}
        mapTableBody={mapTableBody} />

      <Dialog
        open={openDialog}
        onClose={() => setOpenDialog(false)}>
        <DialogTitle
          id="alert-dialog-title">
          {t('template-as-default-title')}
        </DialogTitle>

        <DialogContent>
          <DialogContentText
            id="alert-dialog-description">
            { ongoingCandidate && ongoingCandidate.ongoing
              ? t('template-as-default-remove', { ongoingCandidate })
              : t('template-as-default-message', { ongoingCandidate })
            }
          </DialogContentText>
        </DialogContent>

        <DialogActions>
          <Button
            onClick={() => setOpenDialog(false)}
            color="default">
            {t('cancel')}
          </Button>

          <Button
            onClick={async () => {
              setOpenDialog(false);
              try {
                const result = await setOngoingPrint(dispatch, ongoingCandidate.id, chainId, siteId);
                if (result) {
                  snackbar.showMessage(t('template-as-default', {ongoingTemplate: ongoingCandidate}));
                } else {
                  snackbar.showMessage(t('template-as-default-remove-success', {ongoingTemplate: ongoingCandidate}));
                }
                fetchPrintTemplates(dispatch, chainId, siteId);
              } catch (error) {
                snackbar.showMessage(t('template-as-default-error', {ongoingTemplate: ongoingCandidate}));
              }
            }}
            color="primary">
            {t('save')}
          </Button>
        </DialogActions>
      </Dialog>

    </>
  );
};

const replacePlaceholderFields = (text, campaign) => {
  let previewText = text;
  if(text == null) return '';

  const pattern = placeholders.map(placeholder => placeholder.field).join('|');

  let regex = new RegExp(pattern, 'g');
  let placeholderArray = previewText.match(regex);
  if(placeholderArray == null) {
    //If there aren't any placeholder fields in the text, just return the original previewText
    return previewText;
  }

  let textArray = previewText.split(regex);

  let allTextArray = [];

  for(let i = 0; i < textArray.length; i++) {
    allTextArray.push(textArray[i]);
    if(placeholderArray.length > i) allTextArray.push(placeholderArray[i]);
  }
  return allTextArray.map((text) =>
    replacePlaceholderField(text, campaign)
  );
};

/*Replaces a given text with a placeholder field if it matches a placeholder field.
If there is campaign object included, replace campaign placeholder fields with campaign info
Returns placeholder text in bold*/
const replacePlaceholderField = (text, campaign) => {
  for(let i = 0; i < placeholders.length; i ++) {
    let placeholder = placeholders[i];

    if(text === placeholder.field) {
      let placeholderText;
      if(campaign && placeholder.campaign_accessor) {
        placeholderText = campaign[placeholder.campaign_accessor];

        switch(placeholder.type) {
        case 'date':
          placeholderText = convertIsoDatetimeToDate(placeholderText);
          break;
        case 'euro':
          placeholderText = placeholderText + ' €';
          break;
        default:
          break;
        }

      } else {
        placeholderText = placeholder.placeholder_text;
      }

      if(placeholder.isLink) {
        return <a key={i} target="_blank" rel="noopener noreferrer" href={placeholderText}>{placeholderText}</a>;
      }

      return <b key={i}>{placeholderText}</b>;
    }
  }

  return text;
};


export default PrintTemplateList;
